import React from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import cx from 'classnames';
import Link from '../components/Link';

const GenericNotificationWithLink = (props) => {

  const _getTranslationOptions = () => {
    const options = {};
    if (props.links) {
      for (let i = 0; i < props.links.length; i++) {
        const item = props.links[i];
        const classes = cx('GenericNotificationWithLink__inline-link', `GenericNotificationWithLink__${item.link.className}`);
        options[`link${i + 1}`] = <Link className={classes} to={item.link}>{item.text}</Link>;
      }
    }
    if (props.texts) {
      for (let i = 0; i < props.texts.length; i++) {
        const item = props.texts[i];
        if (item.bold) {
          options[`text${i + 1}`] = <span className="bold_text">{item.text}</span>;
        } else {
          options[`text${i + 1}`] = item.text;
        }
      }
    }
    return options;
  };

  return (
    <div className="GenericNotificationWithLink">
      {T.translate(props.translationKey, _getTranslationOptions())}
    </div>
  );
};

GenericNotificationWithLink.propTypes = {
  links: PropTypes.array,
  texts: PropTypes.array,
  translationKey: PropTypes.string.isRequired,
  // closeNotification is passed by NotificationManager as part of React.cloneElement handling of notification message
  closeNotification: PropTypes.func,
};

export default GenericNotificationWithLink;
